import { render, staticRenderFns } from "./Advokasi.vue?vue&type=template&id=59c910cb"
import script from "./Advokasi.vue?vue&type=script&lang=js"
export * from "./Advokasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports